<ion-list>
  <ng-container *ngIf="!loading; else spinner">
    <ng-container *ngIf="actions.length > 0; else empty">
      <div *ngFor="let action of actions" (click)="ok(action)">
        <span>{{ action.label }}</span>
      </div>
    </ng-container>
    <ng-template #empty>
      <div class="empty" translate="m/task-process/message_action/none"></div>
    </ng-template>
  </ng-container>
  <ng-template #spinner>
    <div class="spinner">
      <ion-spinner></ion-spinner>
    </div>
  </ng-template>
</ion-list>
